import GaugeBar from './GaugeBar';

export default GaugeBar;
